import { z } from 'zod'

import { t } from '../../../locale/utils'
export const PASSWORD_VALIDATION = z
  .string()
  .min(8, {
    message: t('errors.password.min')
  })
  .max(20, {
    message: t('errors.password.max')
  })
  .regex(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    t('errors.password.invalid')
  )
